export default __webpack_public_path__ + "static/media/welpentreffen_55.08dde621.jpg";